var render = function render(_c,_vm){return _c('a',_vm._b({class:['anker', _vm.data.class, _vm.data.staticClass],style:([_vm.data.style || {}, { top: `${_vm.parent.$root.header.inViewportHeight * -1}px` }]),attrs:{"id":_vm.data.attrs.id}},'a',_vm.data.attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }